import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/login/index',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/login/getUserInfo',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}
